import { type DocumentNode, gql } from '@apollo/client';

const newPermissionGroup: DocumentNode = gql`
  mutation new_permissions_group($name: String!, $description: String, $mediaGroups: [MediaGroupInput]) {
    createPermissionsGroup(name: $name, description: $description, mediaGroups: $mediaGroups) {
      permissionsGroup {
        id
        name
        description
        mediaGroups {
          edges {
            node {
              id
              name
              description
            }
          }
        }
        mediapermissionSet {
          edges {
            node {
              id
              profile {
                id
                user {
                  id
                  username
                  email
                }
              }
            }
          }
        }
      }
    }
  }
`;

export default newPermissionGroup;
